import { render, staticRenderFns } from "./buttonReset.vue?vue&type=template&id=55f68355&"
import script from "./buttonReset.vue?vue&type=script&lang=js&"
export * from "./buttonReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports